import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    modelList: [],
    ruleSet: [],
  },
  getters: {
    modelList: (state) => state.modelList,
    ruleSet: (state) => state.ruleSet,
  },
  actions: {
    loadModelList(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadModelList()
          .then((response) => {
            const { data } = response.data;
            data.forEach((model) => {
              const newModel = model;
              if (newModel.lastTrainedAt) {
                newModel.isOutdated = newModel.updatedAt > newModel.lastTrainedAt;
              } else {
                newModel.isOutdated = true;
              }
            });
            context.commit('setModelListData', data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadCategoryList(context, params) {
      const { modelId } = params;
      return new Promise((resolve, reject) => {
        alice
          .loadCategoryList(modelId)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    predict(context, params) {
      const { modelId, modelName, text } = params;
      // console.log('PD', params);
      return new Promise((resolve) => {
        alice
          .predict(modelId, text)
          .then((response) => {
            const result = {
              modelId,
              modelName,
              data: response.data.data,
            };
            resolve(result);
          })
          .catch(() => {
            // console.log(error);
            const result = {
              modelId,
              modelName,
              error: true,
            };
            resolve(result);
          });
      });
    },
    loadRuleSet(context) {
      return new Promise((resolve, reject) => {
        alice
          .loadRuleSet()
          .then((response) => {
            context.commit('setRuleSetData', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkMessageStatus(context, params) {
      const { modelId, message } = params;
      return new Promise((resolve, reject) => {
        alice
          .checkMessageStatus(modelId, message)
          .then((response) => {
            resolve({
              status: response.data.data.status,
              modelId,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setModelListData(state, data) {
      Vue.set(state, 'modelList', data);
    },
    setRuleSetData(state, data) {
      Vue.set(state, 'ruleSet', data);
    },
  },
};
